import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: {
  showFilterModal: boolean;
} = {
  showFilterModal: false,
};

const crmSlice = createSlice({
  name: "crm",
  initialState,
  reducers: {
    setShowFilterModal: (state, action: PayloadAction<any>) => {
      state.showFilterModal = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function

export const crmActions = crmSlice.actions;

export default crmSlice.reducer;
